function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M384 264H264v120h-16V264H128v-16h120V128h16v120h120v16z"
});

const SvgIosAdd = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512 512",
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIosAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ios-add.ac3ac564.svg";
export { ForwardRef as ReactComponent };